import React, { useState, useRef, useEffect } from 'react';
import { ResponsiveTabDropdownProps } from './definitions';
import Icon from '_components/Icon';
import { MaterialIcons } from '_components/Icon/definitions';
import {
    TabPillsContainer,
    TabPill,
    DropdownContainer,
    DropdownHeader,
    DropdownList,
    DropdownItem
} from './StyledResponsiveTabDropdown';

const ResponsiveTabDropdown: React.FC<ResponsiveTabDropdownProps> = ({ items, activeIndex, onTabChange, handleAnalytics }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const activeItem = items[activeIndex] || items[0];

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <>
            <TabPillsContainer>
                {items.map((item, index) => {
                    const isActive = index === activeIndex;
                    return (
                        <TabPill
                            key={item.id}
                            isActive={isActive}
                            onClick={() => {
                                onTabChange(index)
                                handleAnalytics(item.title, item.labelText)
                            }}
                        >
                            {item.icon}
                            {item.label}
                        </TabPill>
                    );
                })}
            </TabPillsContainer>

            <DropdownContainer ref={dropdownRef}>
                <DropdownHeader
                    isOpen={isDropdownOpen}
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                    {activeItem?.label}
                    <Icon name={'expand_more' as MaterialIcons} />
                </DropdownHeader>
                {isDropdownOpen && (
                    <DropdownList>
                        {items.map((item, index) => (
                            <DropdownItem
                                key={item.id}
                                isActive={index === activeIndex}
                                onClick={() => {
                                    onTabChange(index);
                                    handleAnalytics(item.title, item.labelText)
                                    setIsDropdownOpen(false);
                                }}
                            >
                                {item.label}
                            </DropdownItem>
                        ))}
                    </DropdownList>
                )}
            </DropdownContainer>
        </>
    );
};

export default ResponsiveTabDropdown;
